import { createApp } from "vue";
import LoginApp from "./LoginApp.vue";
import ElementPlus from "element-plus";
import "zhihao-ui/dist/index.css";
import "@/views/styles/layout.scss";
import "@/views/styles/_global.scss";
import "@/views/styles/reset.scss";
import "@/views/styles/common.scss";
import "@/views/styles/_flex.scss";
import "@/views/styles/_spacing.scss";
import "@/views/styles/_grid.scss";
import "@/views/styles/element.scss";
import "@/views/assets/iconfont/iconfont.css";
import * as Icons from "@element-plus/icons-vue";
// pinia store
import pinia from "@/stores";
// 预加载全局组件
import * as preComp from "@/utils/preComp";

const app = createApp(LoginApp);

Object.keys(preComp).forEach(key => {
    app.component(key, preComp[key as keyof typeof preComp]);
});

// register the element Icons component
Object.keys(Icons).forEach(key => {
    app.component(key, Icons[key as keyof typeof Icons]);
});
app.use(pinia).use(ElementPlus).mount("#login-app");
